const state = {}

const getters = {
    is_order_placement_allowed: (state, getters) => ['true', 'yes', '1'].includes((getters.getAppEnvParam('IS_ORDER_PLACEMENT_ALLOWED') || '').toLowerCase())
                                                    && (getters.is_show_ufb_module || getters.is_show_fwa_module || getters.is_sim_purchasing_allowed || getters.is_travel_esim_enabled),

    // Cards shown on order-placement, in display order.
    order_placement_types: (state, getters) => {
        const types = []

        if (getters.is_sim_purchasing_allowed && getters.show_order_placement_local_sim) types.push('sim')
        if (getters.is_travel_esim_enabled) types.push('travel-esim')
        if (getters.is_show_ufb_module || getters.is_show_fwa_module) types.push('ufb')

        return types
    },

    // One card only: order-placement is skipped.
    is_order_placement_single_type: (state, getters) => getters.order_placement_types.length === 1,
}

const mutations = {}

const actions = {
    // Remote Config values the card list depends on. Never rejects.
    loadOrderPlacementConfigs({ dispatch }) {
        return Promise.all([
            dispatch('get_is_module_ufb_enabled').catch(() => {}),
            dispatch('get_is_travel_esim_enabled').catch(() => {}),
            dispatch('get_show_order_placement_local_sim').catch(() => {}),
        ])
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
}
